import { render, staticRenderFns } from "./vsTextarea.vue?vue&type=template&id=db811240&lang=html"
import script from "./vsTextarea.vue?vue&type=script&lang=js"
export * from "./vsTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports